import React, { memo, useCallback } from 'react';

import { Stack } from '@mui/material';
import PropTypes from 'prop-types';

import HeaderChatMentionRow from './components/HeaderChatMentionRow';

const HeaderChatMentionsList = memo(({ mentions, onSelectMention }) => {
  const onRowSelect = useCallback(
    ({ chatId, messageId }) => {
      onSelectMention({ chatId, messageId });
    },
    [onSelectMention],
  );

  return (
    <Stack>
      {mentions.map(({ chatId, messageId, channel, message, timestamp }) => (
        <HeaderChatMentionRow
          channel={channel}
          chatId={chatId}
          key={`${chatId}:${messageId ?? timestamp}`}
          message={message}
          messageId={messageId ?? null}
          timestamp={timestamp}
          onSelect={onRowSelect}
        />
      ))}
    </Stack>
  );
});

HeaderChatMentionsList.propTypes = {
  mentions: PropTypes.arrayOf(
    PropTypes.shape({
      chatId: PropTypes.string.isRequired,
      message: PropTypes.object.isRequired,
      messageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      channel: PropTypes.object,
      timestamp: PropTypes.string,
    }),
  ).isRequired,
  onSelectMention: PropTypes.func.isRequired,
};

export default HeaderChatMentionsList;
